
import Vue from 'vue';

interface Props {
  value: any;
  focus: boolean;
  error: boolean;
  autocomplete?: string;
}

interface Methods {
  handleInput: (value: any) => void;
}

export default Vue.extend<unknown, Methods, unknown, Props>({
  directives: {
    focus: {
      inserted(el, binding) {
        if (binding.value) {
          el.focus();
        }
      },
    },
  },
  props: {
    value: {
      type: undefined,
      default: null,
      required: true,
    },
    focus: {
      type: Boolean,
      default: false,
      required: false,
    },
    error: {
      type: Boolean,
      default: false,
      required: false,
    },
    autocomplete: {
      type: String,
      required: false,
    },
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value);
    },
  },
});
